<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal-container">

                    <div class="modal-header">
                        <h2>Next Steps..</h2>
                    </div>

                    <div class="modal-body">

                        <form  class="2fa-form" v-on:submit.prevent>

                            <div class="login-content resetpage-content">

                                <!-- <div class="form-element"> -->
                                    <ul class="nextsteps">
                                        <li v-for="step in nextsteps[selectedapp]">
                                            <b>{{step}}</b>
                                        </li>
                                    </ul>

                                <!-- </div> -->
                                <div class="form-element form-button">
                                    <button type="submit" class="w3-btn signin-btn" @click="$emit('close')">Close</button>
                                </div>

                            </div>

                        </form>

                    </div>

                    <div class="modal-footer">
                        
                    </div>

                </div>

            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue';
export default {
    name: 'PopupModal',
    props: {
        selectedapp: {
            type: String,
            default: 'ep'
        }
    },
    data () {
        return {
            nextsteps: {
                'ep': ['1. EP Step-1', '2. EP Step-2', '3. EP Step-3', '4. EP Step-4'],
                'bd': ['1. BD Step-1', '2. BD Step-2', '3. BD Step-3', '4. BD Step-4'],
                'ida': ['1. IDA Step-1', '2. IDA Step-2', '3. IDA Step-3', '4. IDA Step-4']
            }
        }
    },
    created() {
    },
    methods: {
    }
}
</script>